import { chakra, Box, Img, LinkBox, Text, VStack, Image, Progress, useMediaQuery, Center, Button, Flex, Icon, useDisclosure } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import BottomNavBar from 'components/BottomNavBar';
import React, { useCallback, useContext, useRef, useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackButton from '../../../../../images/assets/telemedicina/backbutton.svg';
import PetsImg from '../../../../../images/assets/telemedicina/pets-white.png';
import especialistas from '../../../../../images/doctor-badge.svg';
import { ReactComponent as InfoCircle } from '../../../../../images/info-circle.svg';
import DesistenciaModal from 'components/Telemedicina/DesistenciaModal';
import ChildHeader from '../../ChildHeader';
import { api } from 'api/api';
import ModalAnexoChamada from '../VideoChamada/AnexoChamada/ModalAnexoChamada';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function Fila() {
  const [md] = useMediaQuery('(min-width: 375px)');

  const { user, setPage } = useContext(AccountContext);
  setPage('Telemedicina');
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [queued, setQueued] = useState(false);
  const [medico, setMedico] = useState('');
  const [paciente, setPaciente] = useState('');
  const [agenda, setAgenda] = useState('');
  const [position, setPosition] = useState(false);
  const today = new Date().toISOString().substring(0, 10);
  const [pausedFetchRdy, setPausedFetchRdy] = useState(false);
  const intervalRef = useRef();
  const [reconnect, setReconnect] = useState(false);
  const { state } = useLocation();
  const [faturado, setFaturado] = useState(true);
  const [error, setError] = useState(false);
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  const url = ENDPOINT + '/schedule/appointment_pet';
  const payload = {
    cpf: onlyNumbers(user.cpf),
    clientId: user.id_cliente_deovita,
    cart: {
      convenio_id: 252,
      dia_previsao: 0,
      grupo: 'ENDOSCOPIA',
      materiais: '',
      nome: 'ENDOSCOPIA',
      procedimento_convenio_id: 6178,
      procedimento_tuss_id: 173059,
      valor: '0,00',
      faturado: true,
    },
    turno: 'manhã',
    valor: 0,
    metadataCoparticipacao: state?.metadataCoparticipacao,
    empresa: {
      ativo: true,
      bairro: 'Centro',
      cep: '63500-065',
      descricao:
        'Iniciamos nossas atividades em 2006, tendo como base fundamental a garantia de um bom atendimento e qualidade. Com união entre profissionais qualificados e tecnologia avançada, conquistamos a confiança de nossos clientes, trazendo resultados com agilidade e precisão.     Além da sede em Iguatu/CE, hoje estamos presentes em Fortaleza, região metropolitana, e em diversas cidades do estado do Ceará.',
      empresa: 'ADOLFO LUTZ',
      empresa_id: 1,
      endereco: 'Rua Deputado Adail Barreto',
      estado: 'CEARA',
      grupo: 'ENDOSCOPIA',
      horario_sab_fim: '13:00',
      horario_sab_inicio: '06:00',
      horario_seg_sex_fim: '18:00',
      horario_seg_sex_inicio: '06:00',
      municipio: 'IGUATU',
      numero: '54',
      ordem: '1',
      telefone_01: '0800 280 2133',
      telefone_02: '88 981189898',
    },
    data: today,
    credito: user.credito_id,
    credito_id: user.credito_id,
  };
  console.log('state', state);
  const fetchPosts = async () => {
    try {
      if (queued === false) {
        setQueued(true);
        const response = await api(url, {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(payload),
        });
        const postsData = await response.json();
        setSuccess(postsData.success);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (success === false && state?.status !== 'telemed_paga') {
      fetchPosts();
    } else if (state?.status === 'telemed_paga') {
      setSuccess(true);
    }
  }, [success, state?.status]);

  async function validaFilaAtendimento(agendaId) {
    return await api(`${ENDPOINT}/cache/telemedicine`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        return res.json();
      })
      .then(async (resposta) => {
        if (resposta.length > 0) {
          return resposta.filter((filtrado) => filtrado.agenda_exames_id == agendaId)[0];
        }
        return null;
      });
  }

  const fetchRdy = useCallback(async () => {
    setError(null);

    try {
      const response = await api(ENDPOINT + `/pet/schedule/${user.username}`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const postsData = await response.json();
 
      setFaturado(true);
      setReconnect(false);
      setPosition(postsData.position);
      setPaciente(postsData.paciente_id);
      setAgenda(postsData.agenda_exames_id);
      console.log('postsData', postsData);
      if (postsData.medico_ready === true) {
        setMedico(postsData.medico_id);
        //setLoading(false);
        const agendamento = await validaFilaAtendimento(postsData.agenda_exames_id);
        console.log('agendamento', agendamento);

        navigate('/pre-video-chamada', {
          state: {
            atendimentoId: postsData.agenda_exames_id,
          },
        });
        return;
        window?.ReactNativeWebView?.postMessage(
          JSON.stringify({
            service: true,
            openInBrowser: false,
            url: `https://atendimento.deovita.com.br:5000/atendimento?p=${postsData.paciente_id}&m=${postsData.medico_id}&a=${postsData.agenda_exames_id}&u=paciente`,
          }),
        );

        /* const isAndroid = user.device === 'android' ? true : false;
        if (isAndroid) {
          window.location = `https://atendimento.deovita.com.br:5000/atendimento?p=${postsData.paciente_id}&m=${postsData.medico_id}&a=${postsData.agenda_exames_id}&u=paciente`;
        } else {
          setLoading(false);
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              service: true,
              url: `https://atendimento.deovita.com.br:5000/atendimento?p=${postsData.paciente_id}&m=${postsData.medico_id}&a=${postsData.agenda_exames_id}&u=paciente`
            })
          );
        } */

        const highestId = window.setTimeout(() => {
          for (let i = highestId; i >= 0; i--) {
            window.clearInterval(i);
          }
        }, 0);
      }
    } catch (error) {
      setError('Problema na rede, verifique se seu dispositivo está conectado a internet');
      console.log(error);
    }
  }, [user.username]);

  // useEffect(() => {
  //   if (success === true) {
  //     setInterval(function () {
  //       fetchRdy();
  //     }, 10000);
  //   }
  // }, [success]);

  useEffect(() => {
    if (success === true && !pausedFetchRdy) {
      intervalRef.current = setInterval(fetchRdy, 10000);
    }

    return () => clearInterval(intervalRef.current);
  }, [success, pausedFetchRdy, fetchRdy]);

  const anexoChamda = useDisclosure();
  useEffect(() => {
    anexoChamda.onOpen();
  }, [agenda]);

  return isLoading ? (
    <>
      <ModalAnexoChamada disclosure={anexoChamda} agenda_exames_id={agenda} preatendimento={true} />
      <Center flexDirection={'column'} minH="100vh" background="#5AB2AE" p={md ? 8 : 4} pb={20}>
        <Box width={'100%'} mb={4}>
          <Image src={BackButton} onClick={() => navigate(-1)} />
        </Box>
        <Box borderRadius={20} backgroundColor="white" textAlign="center" p={md ? 8 : 4} fontSize="xs">
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
            <Image src={especialistas} h={md ? '5em' : '3em'} w={md ? '5em' : '3em'}></Image>

            <Text color="#585858" fontWeight="bold" fontSize={md ? 'lg' : 'sm'} mt={4}>
              Agora é só aguardar!
            </Text>
            <Text fontSize={md ? 'md' : 'sm'}>
              {error != false && error != undefined ? (
                'Falha na conexão'
              ) : position !== null ? (
                position == false || position == undefined ? (
                  'Estamos conectando você ao atendimento...'
                ) : (
                  <Box p={4}>
                    <Text>Você é o </Text>
                    <Text fontSize={'md'} fontWeight="bold" color={'#5AB2AE'}>{`${position}º da fila`}</Text>
                  </Box>
                )
              ) : (
                'iniciando atendimento...'
              )}
            </Text>
          </Box>

          <Box bgColor={'#DFDFDF'} color={'#585858'} p={4} textAlign={'left'} borderRadius={10} mt={md ? 10 : 4}>
            <InfoCircle style={{ height: '1rem' }} />
            <Text mt={4}>
              É importante lembrar que o profissional de saúde pode demorar um pouco mais durante o atendimento. Ou seja, seu lugar na fila e o tempo
              estimado pode aumentar ou diminuir.
            </Text>
          </Box>

          {faturado && position !== false && (
            <DesistenciaModal state={{ ...state, patient: user.cpf }} agenda={agenda} setPausedFetchRdy={setPausedFetchRdy}></DesistenciaModal>
          )}
          <Text mt={5} color="gray.600" textAlign="center" fontSize="1rem" maxW="90%" fontWeight={'medium'}>
            Deseja anexar algum arquivo para o médico avaliar?
          </Text>
          <Button
            bg="#5AB2AE"
            color="white"
            _hover={{ opacity: 0.9 }}
            borderRadius="12px"
            w="100%"
            size="sm"
            onClick={() => anexoChamda.onOpen()}
            mt={3}
            leftIcon={
              <Icon viewBox="0 0 24 24">
                <path fill="currentColor" d="M5 20h14v-2H5m14-9h-4V3H9v6H5l7 7 7-7z" />
              </Icon>
            }
          >
            Anexar arquivos
          </Button>
        </Box>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} fontSize={md ? 'lg' : 'xs'} mt={4}>
          {reconnect === true ? (
            <Text color="white" fontWeight="bold">
              Reconectando...
            </Text>
          ) : (
            <>
              <Text color="white" fontWeight="bold">
                Problemas na conexão?
              </Text>
              <Button
                isFullWidth
                variant="ghost"
                color="white"
                fontSize={md ? 'lg' : 'xs'}
                onClick={() => {
                  setReconnect(true);
                  fetchRdy();
                }}
              >
                Clique aqui para reconectar
              </Button>
            </>
          )}
        </Box>
      </Center>

      {position !== false && position?.length > 0 && <BottomNavBar />}
    </>
  ) : (
    <>
      <ChildHeader />
      <VStack>
        <chakra.iframe
          width="95%"
          paddingTop="0.5em"
          height="600px"
          src={`https://atendimento.deovita.com.br:5000/atendimento?p=${paciente ? paciente : ''}&m=${medico ? medico : ''}&a=${
            agenda ? agenda : ''
          }&u=paciente`}
          allow="camera *;microphone *"
        ></chakra.iframe>
      </VStack>
      <BottomNavBar />
    </>
  );
}

export default Fila;
